import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Grid } from 'semantic-ui-react';
import {
  LAST_5_MINUTES,
  LAST_15_MINUTES,
  LAST_30_MINUTES,
  LAST_HOUR,
  LAST_3_HOURS,
  LAST_6_HOURS,
  LAST_12_HOURS,
  LAST_24_HOURS,
  LAST_WEEK,
  LAST_MONTH,
} from '../../Constants';
import './index.css';

/**
 * Timer range quick
 * Parameters (Props):
 * @param timeframes: PropTypes.objectOf(Object).isRequired,
 * @param selectTimeFrame: PropTypes.func.isRequired,
 */
export default class TimeRangeQuick extends React.PureComponent {
  constructor(props) {
    super(props);
    this.viewTimeRangeQuick = this.viewTimeRangeQuick.bind(this);
  }

  /**
   * View tiem range quick
   */
  viewTimeRangeQuick() {
    const { selectTimeFrame, timeframes } = this.props;
    return (
      <Grid.Row columns={2} divided className="time-range-quick">
        <Grid.Column>
          <Dropdown.Item
            className="option"
            onClick={() => selectTimeFrame(LAST_5_MINUTES)}
          >
            {timeframes[LAST_5_MINUTES].name}
          </Dropdown.Item>
          <Dropdown.Item
            className="option"
            onClick={() => selectTimeFrame(LAST_15_MINUTES)}
          >
            {timeframes[LAST_15_MINUTES].name}
          </Dropdown.Item>
          <Dropdown.Item
            className="option"
            onClick={() => selectTimeFrame(LAST_30_MINUTES)}
          >
            {timeframes[LAST_30_MINUTES].name}
          </Dropdown.Item>
          <Dropdown.Item
            className="option"
            onClick={() => selectTimeFrame(LAST_HOUR)}
          >
            {timeframes[LAST_HOUR].name}
          </Dropdown.Item>
          <Dropdown.Item
            className="option"
            onClick={() => selectTimeFrame(LAST_3_HOURS)}
          >
            {timeframes[LAST_3_HOURS].name}
          </Dropdown.Item>
        </Grid.Column>
        <Grid.Column>
          <Dropdown.Item
            className="option"
            onClick={() => selectTimeFrame(LAST_6_HOURS)}
          >
            {timeframes[LAST_6_HOURS].name}
          </Dropdown.Item>
          <Dropdown.Item
            className="option"
            onClick={() => selectTimeFrame(LAST_12_HOURS)}
          >
            {timeframes[LAST_12_HOURS].name}
          </Dropdown.Item>
          <Dropdown.Item
            className="option"
            onClick={() => selectTimeFrame(LAST_24_HOURS)}
          >
            {timeframes[LAST_24_HOURS].name}
          </Dropdown.Item>
          <Dropdown.Item
            className="option"
            onClick={() => selectTimeFrame(LAST_WEEK)}
          >
            {timeframes[LAST_WEEK].name}
          </Dropdown.Item>
          <Dropdown.Item
            className="option"
            onClick={() => selectTimeFrame(LAST_MONTH)}
          >
            {timeframes[LAST_MONTH].name}
          </Dropdown.Item>
        </Grid.Column>
      </Grid.Row>
    );
  }

  render() {
    const viewTimeRangeQuick = this.viewTimeRangeQuick();
    return viewTimeRangeQuick;
  }
}

TimeRangeQuick.propTypes = {
  timeframes: PropTypes.objectOf(Object).isRequired,
  selectTimeFrame: PropTypes.func.isRequired,
};
